import React from 'react';

// ช่องค้นหามาตรฐานของทั้งระบบ: มีปุ่ม "✕ ล้าง" ติดอยู่ข้าง ๆ เสมอ (กฎ: ทุกช่องค้นหาต้องมีปุ่มล้าง)
// ใช้แทน <input> ได้ทันที — props เหมือน input ปกติ (value, onChange(event), placeholder, style ...)
export default function SearchInput({ value, onChange, style = {}, onClear, ...rest }) {
  const { flex, minWidth, maxWidth, width, ...inputStyle } = style;
  const clear = () => { if (onClear) onClear(); else if (onChange) onChange({ target: { value: '' } }); };
  return <span style={{ display: 'flex', gap: 6, alignItems: 'stretch', flex: flex || '1 1 240px', minWidth: minWidth || 0, maxWidth: maxWidth || '100%', width }}>
    <input type="text" value={value} onChange={onChange} {...rest}
      onKeyDown={(e) => { if (e.key === 'Escape') clear(); if (rest.onKeyDown) rest.onKeyDown(e); }}
      style={{ ...inputStyle, flex: '1 1 auto', minWidth: 0, width: 'auto', boxSizing: 'border-box' }} />
    <button type="button" onClick={clear} disabled={!value} title="ล้างคำค้น (หรือกด Esc)"
      style={{ font: 'inherit', flex: '0 0 auto', padding: '0 12px', borderRadius: 8, border: '1px solid #cbd5e1', background: value ? '#fff' : '#f8fafc', color: value ? '#334155' : '#94a3b8',
        fontWeight: 700, fontSize: 13, cursor: value ? 'pointer' : 'default', whiteSpace: 'nowrap' }}>✕ ล้าง</button>
  </span>;
}
